package dev.moetz.fakeitandmakeit.page

import dev.moetz.fakeitandmakeit.design.mFooter
import dev.moetz.materialize.mCol
import dev.moetz.materialize.mContainer
import dev.moetz.materialize.mHeader
import dev.moetz.materialize.mRow
import react.FC
import react.Props
import react.dom.html.ReactHTML.p

external interface NotFoundPageServiceProps : Props {
}

val NotFoundPageService = FC<NotFoundPageServiceProps> { props ->
    mHeader("Travel Diary")

    mContainer {
        mRow {
            mCol(small = 12) {
                p {
                    +"Page not found"
                }
            }
        }
    }

    mFooter()
}